import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../abstract/api.service';
import { InvitationEmailResult } from '../response-models/invitation-email-result.model';
import { toInvitationEmailResult } from '../utils/invitation-result-utils';

/**
 * POST /admin/organization-invitations/:id/send-email (hub `admin-organization-invitations-controller.ts`):
 * the first email of an organization invitation. `OrganizationInvitationService` delegates here.
 */
@Injectable({ providedIn: 'root' })
export class OrganizationInvitationEmailService extends ApiService {
  constructor() {
    super('admin/organization-invitations');
  }

  sendEmail(invitationId: string): Observable<InvitationEmailResult> {
    return this.request('POST', { id: invitationId, path: 'send-email' }, toInvitationEmailResult, {});
  }
}
